import { cn } from '~/shadcn/lib/utils'
import { FieldError } from '~/shadcn/ui/field'

type Props = {
  error: string
  className?: string
}

function FormError(props: Props) {
  return (
    <FieldError
      className={cn(
        'text-sm font-medium text-destructive text-center py-2',
        props.className
      )}>
      {props.error}
    </FieldError>
  )
}

export { FormError }
